import { To, NavigateOptions } from "react-router-dom";

export * from "./HandleError";
export * as Validate from "./Validate";
export * from "./messageContracts";
export * from "./commandParser";

export const getVersion = (): string => {
	const environment_name: Record<string, string> = {
		prod: "",
		hml: "STAGING:",
		dev: "DEV:",
	};

	return `${environment_name[process.env.REACT_APP_ENVIRONMENT || "prod"]}${process.env.REACT_APP_VERSION}`;
};

let navigator: NavigateFunction | undefined;

export const setNavigator = (nav: NavigateFunction) => {
	navigator = nav;
};

interface NavigateOptionsExtended extends NavigateOptions {
	preserveQueryParams?: boolean;
}

interface NavigateFunction {
	(to: To, options?: NavigateOptionsExtended): void | Promise<void>;
	(delta: number): void | Promise<void>;
}

export const navigate: NavigateFunction = (...args) => {
	if (!navigator) {
		console.warn("Navigator not set");
		return;
	}

	let { to, options, delta } = ((args) => ({
		to: typeof args[0] === "number" ? undefined : args[0],
		options: (args[1] || {}) as NavigateOptionsExtended,
		delta: typeof args[0] === "number" ? args[0] : undefined,
	}))(args);

	if (delta !== undefined) {
		return navigator(delta);
	}

	const { preserveQueryParams = false, ...restOptions } = options || {};

	if (typeof to === "string" && preserveQueryParams) {
		const currentSearch = window.location.search;
		const separator = to.includes("?") ? "&" : "?";
		to = currentSearch ? `${to}${separator}${currentSearch.slice(1)}` : to;
	} else if (typeof to === "object" && to !== null && preserveQueryParams) {
		const currentSearch = window.location.search;
		const separator = to.search ? "&" : "?";
		const newSearch = currentSearch ? `${to.search || ""}${separator}${currentSearch.slice(1)}` : to.search;
		to = { ...to, search: newSearch };
	}

	return navigator(to as any, restOptions);
};

export function sanitizeEmailPrefix(email: string): string {
	// Divide a string de email em duas partes: antes e depois do @
	const [prefix, domain] = email.split("@");

	// Define o regex para os caracteres permitidos
	const allowedCharacters = /^[a-zA-Z0-9_.]+$/;

	// Filtra os caracteres da parte antes do @ que correspondem ao regex
	const sanitizedPrefix = prefix
		.split("")
		.filter((char) => allowedCharacters.test(char))
		.join("");

	return `${sanitizedPrefix}_${Math.random().toString(36).substring(2, 11)}`;
}

export const debounce = <F extends Function>(func: F, wait: number): F => {
	let timeout: NodeJS.Timeout;

	return function (this: any, ...args: any[]) {
		const context: any = this;

		clearTimeout(timeout);

		timeout = setTimeout(() => {
			func.apply(context, args);
		}, wait);
	} as unknown as F;
};
